import { FC, ReactNode } from 'react';
import { motion, useReducedMotion } from "motion/react";
import { Box } from "@mui/material";

interface FlipProps {
    isFlipped: boolean;
    frontView: ReactNode;
    backView: ReactNode;
}

const Flip: FC<FlipProps> = ({ isFlipped = false, frontView, backView }) => {
    const shouldReduceMotion = useReducedMotion();

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                perspective: '1000px',
            }}
        >
            <motion.div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    transformStyle: 'preserve-3d',
                }}
                initial={shouldReduceMotion ? false : { rotateY: 0 }}
                animate={{ rotateY: isFlipped ? 180 : 0 }}
                transition={shouldReduceMotion
                    ? { duration: 0 }
                    : { duration: 0.9, delay: 0.9, ease: [0.16, 1, 0.3, 1] }
                }
            >
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        backfaceVisibility: 'hidden',
                    }}
                >
                    {frontView}
                </Box>
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        backfaceVisibility: 'hidden',
                        transform: 'rotateY(180deg)',
                    }}
                >
                    {backView}
                </Box>
            </motion.div>
        </Box>
    );
};

export default Flip;
